export function setLeftCharmsRegionWidth(
    leftCharmsRegionId: string,
    leftCharmsWidth: number
): void {
    const leftCharmsRegion = document.getElementById(leftCharmsRegionId);
    leftCharmsRegion?.setAttribute(
        'style',
        'flex: 0 0 auto;min-width:' + leftCharmsWidth + 'px;display:flex'
    );
}
